module.exports = __webpack_public_path__ + "img/slack.e1047240.png";